import { render, staticRenderFns } from "./YearDropdown.vue?vue&type=template&id=920639b0&"
import script from "./YearDropdown.vue?vue&type=script&lang=ts&"
export * from "./YearDropdown.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports